// EWM-403 — profanity gate for the search query.
//
// Searching a profane term must return "No results" rather than products.
// This is a deliberately small, in-repo blocklist (no runtime dependency) —
// extend `PROFANITY_TERMS` as needed. Matching is token-based and exact
// (after stripping separators) to avoid the "Scunthorpe problem", i.e. clean
// words that merely *contain* a blocked substring (e.g. "assistant",
// "cockpit", "Scunthorpe") must NOT be flagged.

// Lowercase, separator-free canonical forms of blocked terms.
const PROFANITY_TERMS = new Set<string>([
  'fuck',
  'fucker',
  'fucking',
  'motherfucker',
  'shit',
  'bullshit',
  'bitch',
  'bastard',
  'asshole',
  'arsehole',
  'dickhead',
  'cunt',
  'wanker',
  'bollocks',
  'prick',
  'slut',
  'whore',
  'nigger',
  'nigga',
  'faggot',
  'retard',
  'cock',
  'pussy',
  'twat',
]);

// Reduce a raw token to a comparable form: lowercase + drop everything that
// isn't a letter or digit. So "F.U.C.K", "f-u-c-k" and "Fuck!" all collapse
// to "fuck". Returns '' for tokens with no alphanumerics.
const canonicalize = (token: string): string => token.toLowerCase().replace(/[^a-z0-9]/g, '');

/**
 * True when any whitespace-separated token in the query is a blocked term.
 * Token-exact (not substring) so "assistant"/"cockpit" never match.
 */
export const isProfaneQuery = (query: string | undefined | null): boolean => {
  if (!query) return false;
  return query
    .split(/\s+/)
    .map(canonicalize)
    .some((token) => token.length > 0 && PROFANITY_TERMS.has(token));
};
